import {
  uniqueArtifacts,
  uniqueAttachments,
  type AgentArtifact,
  type ChatAttachment,
  type MessageCitation,
} from '@hub/contracts'
import type { ChatMessage } from '@/lib/collab/use-chat-collab'

/** Everything a thread has produced or referenced — what the workspace panel lists. */
export interface WorkspaceItems {
  tasks: AgentArtifact[]
  documents: AgentArtifact[]
  citations: Array<MessageCitation & { index: number }>
  attachments: ChatAttachment[]
  count: number
}

export function collectWorkspaceItems(messages: ChatMessage[]): WorkspaceItems {
  const artifacts: AgentArtifact[] = []
  const citationMap = new Map<string, MessageCitation>()
  const attachments: ChatAttachment[] = []
  for (const m of messages) {
    if (m.deletedAt) continue
    for (const a of m.artifacts ?? []) artifacts.push(a)
    for (const c of m.citations ?? [])
      if (!citationMap.has(c.documentId)) citationMap.set(c.documentId, c)
    for (const att of m.attachments ?? []) attachments.push(att)
  }
  const list = uniqueArtifacts(artifacts)
  const files = uniqueAttachments(attachments)
  const tasks = list.filter((a) => a.kind === 'task')
  const documents = list.filter((a) => a.kind === 'document')
  const citations = [...citationMap.values()].map((c, i) => ({ ...c, index: i + 1 }))
  return {
    tasks,
    documents,
    citations,
    attachments: files,
    count: tasks.length + documents.length + citations.length + files.length,
  }
}
